import { UnitPricing } from "@covertree/agent-portal-graphql";

export const reduceFees = (
  pricing: Pick<UnitPricing, "fees" | "installments"> | undefined
): number => {
  if (pricing?.installments?.length) {
    return pricing.installments.reduce(
      (sum, inst) => sum + (inst?.fees ?? 0),
      0
    );
  }

  return 0;
};
